import {
  VuexModule,
  Module,
  getModule,
  Action,
  Mutation,
} from 'vuex-module-decorators';

import store from '@/store';
import { IStatementStatusInfo } from '@/utils/types';
import { ErrorAlertModule } from '@/store/modules/errors';
import { getStatementStatusInfoByID } from '@/api/statements';
import { errorHandler } from "@/utils/common";

export interface IStatementStatusInfoState {
  entity: IStatementStatusInfo | null;
  loading: boolean;
  loaded: boolean;
}

@Module({ dynamic: true, store, name: 'statementStatusInfo', namespaced: true })
class StatementStatusInfo
  extends VuexModule
  implements IStatementStatusInfoState {
  public entity: IStatementStatusInfo | null = null;
  public loading = false;
  public loaded = false;

  @Mutation
  private pending() {
    ErrorAlertModule.setErrorAlert('');
    this.entity = null;
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  private fulfilled(payload: IStatementStatusInfo) {
    this.entity = payload;
    this.loading = false;
    this.loaded = true;
  }

  @Mutation
  private rejected(payload: unknown) {
    this.loading = false;
    errorHandler(payload)
  }

  @Action
  public async get(id: string) {
    this.pending();

    try {
      const statementStatusInfo = await getStatementStatusInfoByID(id);
      if (statementStatusInfo) {
        this.fulfilled(statementStatusInfo);
      } else {
        // Открытие заявления другого пользователя: возвращает 200 и пустоту
        this.rejected('Заявление не найдено');
      }
    } catch (error) {
      this.rejected(error);
    }
  }
}

export const StatementStatusInfoModule = getModule(StatementStatusInfo);
